export const shoppingTipsArticleId = 226;
